import { render, staticRenderFns } from "./especies.vue?vue&type=template&id=526ba331&"
import script from "./especies.vue?vue&type=script&lang=js&"
export * from "./especies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports